type Dimension = {
  spacing: number;
};

export default {
  spacing: 8,
} as Dimension;
